import {useLocation} from 'react-router-dom';
import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {PublicDocsLayout} from '@app/docs/public-docs-layout';

/** Fallback: если splat-маршрут /docs/* не сработал, всё равно не показываем 404. */
export function DocsCatchAllRoute() {
  const {pathname} = useLocation();

  if (pathname === '/docs' || pathname.startsWith('/docs/')) {
    return <PublicDocsLayout />;
  }

  return <NotFoundPage />;
}
